import { FREE_CAPACITY_COCKPIT } from "~/utils/url/staticUrls";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { MyCompanyMenu } from "~/features/navigation/components/MyCompanyMenu";
import { useSimpleMenuState } from "~/common/components/Menu/Menu";
import { PersonalNavItem } from "~/features/navigation/components/headerMenu/PersonalNavItem";
import { FccAction, trackFccAction } from "~/features/freeCapacityPush/api/trackFccAction";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import { useRef } from "react";
import { NAVIGATION_HOVER_DELAY } from "~/utils/uiConstants";

const FCC = () => {
  const { t } = useTranslation();
  const showNew = window.SCHA.config.fccShowNewLabelEnabled;

  return (
    <a
      href={FREE_CAPACITY_COCKPIT}
      data-test-id={"free-capacity-cockpit"}
      onClick={() => trackFccAction(FccAction.IconClick)}
    >
      <PersonalNavItem
        data-test-id={"header-btn-free-capacity-cockpit"}
        icon={<Icon type={IconType.BallBearing} size={24} style={{ color: C_ON_SURFACE_VARIANT }} />}
        name={t("page.fcc.title")}
        badgeContent={showNew ? t("page.abmonitor.badge.new") : undefined}
        badgeVariant={"new"}
      />
    </a>
  );
};

const MyCompany = () => {
  const { t } = useTranslation();
  const [isOpen, handleClick, handleClose, anchorEl] = useSimpleMenuState();

  const hoverFunc = useHoverDelay(handleClick, NAVIGATION_HOVER_DELAY);

  return (
    <>
      <PersonalNavItem
        name={t("header.link.my.company")}
        icon={<BusinessOutlinedIcon />}
        data-test-id={"header-btn-my-company"}
        {...hoverFunc}
        onClick={handleClick}
      />
      <MyCompanyMenu open={isOpen} anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};

export const NavItems = {
  FCC,
  MyCompany,
};

const useHoverDelay = (fun: (e: React.MouseEvent<HTMLButtonElement>) => void, delay: number) => {
  const timeoutRef = useRef<number>();

  const onMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      fun(e);
    }, delay);
  };

  const onMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  return {
    onMouseEnter,
    onMouseLeave,
  };
};
